import { ChipColor, ChipTextColor } from "@tiny/components/src/Chip/Chip.types";
import { isArrayEquals } from "@tiny/components/src/utils/arrayUtils";
import { TimeAction } from "@tiny/components/src/ItemActionTimeInfo/ItemActionTimeInfo.types";
import {
  CustomerStatuses,
  SubscriberSortOption,
} from "./SubscribersList.types";

export const itemsPerPageOptions = [5, 10, 15, 20];

export const sortSubscribersOptions: SubscriberSortOption[] = [
  { label: "Most Opens", value: ["open,DESC", "id,desc"] },
  { label: "Most Clicks", value: ["clicked,DESC", "id,desc"] },
  { label: "Most Recently Updated", value: ["updatedAt,DESC"] },
];

export const pageableDefault = {
  page: 0,
  size: itemsPerPageOptions[3],
  sort: sortSubscribersOptions[0].value,
};

export function getChipColor(status: string): ChipColor {
  switch (status) {
    default:
      return "grey";
  }
}

export function getSortAction(
  sort?: string[],
  sortOptions?: SubscriberSortOption[]
): TimeAction | undefined {
  return sort
    ? sortOptions?.find((s) => isArrayEquals(s.value, sort))?.action
    : undefined;
}

export const STATUS_COLORS: Record<string, ChipTextColor> = {
  Bounced: "yellow",
  Spam: "red",
};

export const subscribersStatuses: CustomerStatuses = [
  "Subscribed",
  "Unsubscribed",
  "Bounced",
  "Spam",
];
